// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { forwardRef, ReactNode } from 'react';

import { BaseProps } from '../Base';
import { StyledHeading } from './Styled';

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

export interface HeadingProps extends BaseProps {
  /** The children element(s) within a heading. */
  children: ReactNode | ReactNode[];
  /** The level of heading from 1 to 6. 1 defines the most important heading, 6 defines the least important heading. */
  level: HeadingLevel;
  /** 中央寄せにするかどうか */
  alignCenter?: boolean;
  /** 文字色 */
  color?: 'primary' | 'gray';
}

export const Heading = forwardRef(
  (props: HeadingProps, ref: React.Ref<HTMLElement>) => {
    const { tag, children, className, level, color, ...rest } = props;

    return (
      <StyledHeading
        as={tag || `h${level}`}
        className={className || ''}
        level={level}
        color={color}
        ref={ref}
        data-testid="heading"
        {...rest}
      >
        {children}
      </StyledHeading>
    );
  }
);
Heading.displayName = 'Heading';

export default Heading;
